<div class="modal-content--ads">
    <button mat-icon-button class="close p-0" mat-dialog-close aria-label="Cerrar"><mat-icon>close</mat-icon></button>

    <div class="text-center" style="padding: 48px !important;">
        <h3 class="fw-bold mb-3">{{ data?.title }}</h3>
        <p class="mb-0">{{ data?.body }}</p>
    </div>
</div>
